import React from "react"
import { Bar } from "react-chartjs-2"
import _ from "underscore"

function BarChart({
  title,
  labels,
  datasets,
  onClick,
  max = null,
  mb = "0",
  stepSize = null,
  formatPercentage = false,
  legend = false,
  graphUrlBase64 = null,
  fixedSize = null,
}) {
  const data = {
    labels,
    datasets,
  }
  const options = {
    // See OldBarChart: an off-screen chart captured for a PDF needs a deterministic canvas size,
    // otherwise the aspect-ratio height overflows the capture box and clips the x-axis labels.
    responsive: !fixedSize,
    maintainAspectRatio: !fixedSize,
    onClick: (event, element) => {
      if (element.length && onClick) {
        onClick(element[0].index)
      }
    },
    onHover: (event, chartElement) => {
      if (onClick) {
        event.native.target.style.cursor = chartElement[0]
          ? "pointer"
          : "default"
      }
    },
    plugins: {
      // chartjs-plugin-datalabels is registered globally by other chart components (e.g. on the
      // school progress report), so switch it off explicitly to keep bars label-free everywhere.
      datalabels: {
        display: false,
      },
      legend: {
        display: legend,
      },
      tooltip: {
        enabled: _.isNull(graphUrlBase64) ? true : graphUrlBase64.length > 0,
        callbacks: {
          label: (tooltipItem) => ` ${tooltipItem.dataset.label}: ${tooltipItem.formattedValue}${
            formatPercentage ? "%" : ""
          }`,
        },
      },
    },
    scales: {
      y: {
        max,
        beginAtZero: true,
        ticks: {
          stepSize,
        },
      },
    },
  }
  if (title) {
    options.plugins.title = {
      display: true,
      text: title,
    }
  }
  return (
    <div className={`mb-${mb}`}>
      <Bar
        data={data}
        options={options}
        width={fixedSize ? fixedSize.width : undefined}
        height={fixedSize ? fixedSize.height : undefined}
      />
    </div>
  )
}
export default BarChart
